import React from "react";
import ToggleImage from '../../../img/toggle.svg'
import { TabData } from "../../../components/InterfaceInfo";
import { RightPanelTab } from "./RightPanelTab";
import {Menu, Close} from '@mui/icons-material/';

const tabData: TabData = JSON.parse(process.env.REACT_APP_TAB || '{}');

function Rightscreen({ handleClick, menuIndex }: { handleClick: (value: boolean) => void, menuIndex: number }) {

    return (
        <div className="bg-gray-50 relative">
            <div className="flex items-center justify-between px-4 bg-gray-200 border-b border-gray-400 sticky top-0 z-10">
                <h2 className="flex items-center font-semibold text-gray-700 text-xl leading-[55px]">
                    <img
                        src={ToggleImage}
                        alt="Icon"
                        width="24"
                        height="24"
                        style={{ filter: 'brightness(1) saturate(0%)' }}
                        className="mr-2"
                    />
                    {tabData.details_of_menus[menuIndex].right_screen?.name}
                </h2>
                <ToggleButton
                    handleClick={handleClick}
                    styleName="bg-white-200 hover:bg-gray-300"
                    value={false}
                />
            </div>

            <div className="space-y-4">
                {tabData.details_of_menus[menuIndex].right_screen?.section_details?.map((section, key) => {
                    return <RightPanelTab section={section} sectionNumber={key} key={key} />;
                })}
            </div>
        </div>
    );
}

export function ToggleButton({ handleClick, value, styleName }: { handleClick: (value: boolean) => void, value: boolean, styleName: string }) {
    return (
        <button
            onClick={() => handleClick(value)}
            className={`absolute bg-white top-4 right-4 ${styleName} text-sm px-3 py-1 rounded`}
        >
            <span >
                {value ? <Menu /> : <Close />}
            </span>

        </button>
    )
}

export default Rightscreen;
